<template>
  <div>
    <div class="consent-education-3 common-consent-edu" v-if="currentQuestion && isEligibleOrNotEligibleToJoin == null">
      <p
        class="verify-name m-0 pb-48"
        :key="currentQuestion.id"
        v-translate:dynamic_string="{
          key: `${currentQuestion.id}_body`,
          val: lang,
          html: currentQuestion.body
        }"
      >
        {{ currentQuestion.body }}
      </p>
      <div v-if="currentQuestion.type == 'Boolean'">
        <b-form-radio-group :key="currentQuestion.id" v-model="answer" @input="onAnswerClick" stacked ref="radioGroup">
          <b-form-radio class="light" v-for="option in currentQuestion.options" :key="`${currentQuestion.id}_options_${option.value}`" :value="option.value">
            <span
              class="cursor-pointer"
              v-translate:dynamic_string="{
                key: `${currentQuestion.id}_options_${option.value}_${option.label ? 'label' : 'body'}`,
                val: lang,
                html: option.label ? option.label : option.body
              }"
              >{{ option.label ? option.label : option.body }}</span
            >
          </b-form-radio>
        </b-form-radio-group>
      </div>
      <div v-if="currentQuestion.type == 'MultiChoice'">
        <b-form-group class="mb-5">
          <b-form-radio-group :key="currentQuestion.id" v-model="answer" stacked @input="onAnswerClick">
            <b-form-radio v-for="option in currentQuestion.options" :key="option.id ? option.id : option.value" :value="option.id ? option.id : option.value" class="light">
              <span
                class="cursor-pointer wrap-option-text"
                v-translate:dynamic_string="{
                  key: `${currentQuestion.id}_options_${option.value}_${option.displayText ? 'displayText' : 'body'}`,
                  val: lang,
                  html: option.displayText ? option.displayText : option.body ? option.body : option.label
                }"
                v-html="option.displayText ? option.displayText : option.body ? option.body : option.label"
              ></span>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
      <div class="text-center pt-80 ml-15 mr-15">
        <button class="btn btn-submit primary-bg" :disabled="nextButtonDisabled" @click="nextQuestion" v-translate:text_signin_button="lang">
          Next
        </button>
      </div>
    </div>
    <div v-if="isEligibleOrNotEligibleToJoin == false && isEligibleOrNotEligibleToJoin != null">
      <div class="consent-education-4 common-consent-edu">
        <div class="text-center">
          <img :src="getStudyIcon" alt="" class="edu-green-check" />
        </div>
        <p class="verify-name m-0" v-translate:label_ineligibility_greetings="lang">
          Thank you for your interest!
        </p>
        <p class="edu-consent-text m-0" v-translate:label_ineligibility_desc="lang">
          Unfortunately, you are not eligible for this study.
        </p>
        <div class="text-center pt-42 ml-15 mr-15">
          <button class="btn btn-submit primary-bg" @click="onWrongAnswer" v-translate:rsb_done="lang">
            Done
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Consent, Widget, Bitrise, ParticipantPortal, Participant } from "@/components/services/participant-service";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";

export default {
  name: "join-eligibility-questions",
  components: {},
  props: ["isOnBackClick", "lang", "currentConsent", "page"],
  data() {
    return {
      widget: new Widget(),
      portal: new ParticipantPortal(),
      consent: new Consent(),
      participantDetails: new Participant(),
      bitrise: new Bitrise(),
      currentQuestionIndex: 0,
      nextButtonDisabled: true,
      isEligibleOrNotEligibleToJoin: null,
      isEligible: false,
      answer: null,
      questions: [],
      eligibilityAns: []
    };
  },
  watch: {
    isOnBackClick(val) {
      if (!val) {
        return;
      }

      if (this.currentQuestionIndex == 0 || this.isEligibleOrNotEligibleToJoin === false) {
        //Particiapnt is on first question OR on the not eligible screen and clicked back button, redirect him to join intro screen.
        this.onWrongAnswer();
        return;
      }

      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex -= 1;
      }

      if (this.currentQuestionIndex >= 0 && this.currentQuestion["sequence"] !== undefined) {
        //Set the previous value selected
        this.answer = this.currentQuestion.sequence;
        this.nextButtonDisabled = false;
      }
    }
  },
  computed: {
    ...mapGetters(["participant"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    currentQuestion() {
      return this.questions[this.currentQuestionIndex];
    },
    getStudyIcon() {
      return this.bitrise.getImage("tintedlogo");
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    getSiteID() {
      return this.study && this.study.sitesInfo[0] && this.study.sitesInfo[0].id;
    }
  },
  created() {
    this.portal.getOpenStudyEligibilityData().then(
      response => {
        this.questions = response && response.studyEligibilityQuestions ? response.studyEligibilityQuestions : [];
      },
      () => {
        const message = this.widget.translate("DATA_SYNC_ERROR_MSG", "Problem in fetching study details.");
        this.$toastr.error(message);
      }
    );
  },
  mounted() {
    const eligibilityHeader = this.widget.translate("label_eligibility", "Eligibility");
    this.$emit("updateHeaderNav", {
      showBlankHeader: true,
      title: eligibilityHeader
    });
  },
  methods: {
    onWrongAnswer() {
      this.currentQuestionIndex = 0;
      this.isEligibleOrNotEligibleToJoin = null;
      this.$emit("updateActiveScreen", "joinIntro");
    },
    onCorrectAnswer() {
      this.$emit("updateActiveScreen", "isActivationCodeVerified");
    },
    onAnswerClick() {
      if (!this.answer || this.answer == "") {
        return;
      }
      this.nextButtonDisabled = false;
      this.currentQuestion.sequence = this.answer;
    },
    onSuccess() {
      this.$emit("updateActiveScreen", "isActivationCodeVerified");
      this.$emit("onEligibilityCheck", this.eligibilityAns);
    },
    onFailure() {
      this.isEligibleOrNotEligibleToJoin = false;
      _.map(this.questions, item => {
        delete item.sequence;
      });
      const eligibilityHeader = this.widget.translate("label_eligibility", "Eligibility");
      this.$emit("updateHeaderNav", {
        showBlankHeader: true,
        title: eligibilityHeader
      });
    },
    onNextQuestion() {
      if (this.questions.length > this.currentQuestionIndex) {
        this.currentQuestionIndex = this.currentQuestionIndex + 1;
        if (this.currentQuestion && this.currentQuestion["sequence"] !== undefined) {
          this.answer = this.currentQuestion.sequence;
          this.nextButtonDisabled = false;
        } else {
          this.nextButtonDisabled = true;
          this.answer = "";
        }

        this.$emit("pageChange", this.currentQuestionIndex);
      }
    },
    nextQuestion() {
      const { type, id, body, options, expectedAnswer, expectedAnswers } = this.currentQuestion;
      let questionLabel = options.filter(item => item.value == expectedAnswer);
      if (questionLabel.length == 0 && expectedAnswers) {
        questionLabel = options.filter(item => expectedAnswers.indexOf(item.value) > -1);
      }
      const eligibility = {
        appLanguageId: this.portal.getLanguage(),
        createdTime: new Date(),
        deviceId: uuidv4(),
        displayLanguage: this.lang,
        displayQuestionAnswer: questionLabel[0].label,
        displayQuestionBody: this.widget.i18nActivities(`${this.currentQuestion.identifier}_body`) === false ? body : this.widget.i18nActivities(`${this.currentQuestion.identifier}_body`),
        questionAnswer: questionLabel[0].label,
        questionBody: body,
        questionId: id,
        questionType: type,
        siteId: this.getSiteID,
        studyId: this.portal.getStudy(),
        studyVersionId: this.portal.getVersion(),
        type: "eligibility"
      };

      let ansIndex = this.eligibilityAns.findIndex(obj => {
        return obj.questionId == id;
      });

      if (ansIndex >= 0) {
        this.eligibilityAns[ansIndex] = eligibility;
      } else {
        this.eligibilityAns.push(eligibility);
      }

      if (this.currentQuestionIndex == this.questions.length - 1 && this.questions.length === this.eligibilityAns.length) {
        let eligible = true;
        for (let i = 0; i < this.questions.length; i++) {
          if (!this.questions[i].expectedAnswers.includes(this.questions[i].sequence)) {
            eligible = false;
            break;
          }
        }
        if (eligible) {
          this.onSuccess();
        } else {
          this.onFailure();
        }
      } else {
        this.onNextQuestion();
      }
    }
  }
};
</script>
